<div class="options-button-wrapper" (clickOutside)="active=false" (genOutsideClick)="outSideClickClose?closeOptions($event):null">
  <button class="btn btn-split-quiet__button" (click)="active=!active" [disabled]="disabled">
    <span class="btn-icon btn__icon {{buttonIconClass}}"></span>
    {{buttonText | stringTranslate}}
  </button>
  <button class="btn btn-split-quiet__button" (click)="active=!active" [disabled]="disabled">
    <i class="fa fa-caret-down"></i>
  </button>
  <section class="options-button-options-wrapper" [ngClass]="{'options-shown':active}">
    <span class="options-button-single-option" *ngFor="let option of options; trackBy:trackByFn"
          (click)="active=false;option.command();">{{option.label | stringTranslate}}</span>
  </section>
</div>
